module.exports = __webpack_public_path__ + "img/research_2.9d0c0c18.jpg";